























































import {Component, Vue} from 'vue-property-decorator';
import {Getter, Action} from 'vuex-class';
import Card from '../../../components/material/Card.vue';
import articles from '@/modules/articles';
import DlgArticleEmailGenerator from '@/modules/articles/_components/DlgArticleEmailGenerator.vue';
import DlgArticleDelete from '@/modules/articles/_components/DlgArticleDelete.vue';
import Loader from '@/components/Loader.vue';

@Component({
  components: {
    Loader,
    DlgArticleDelete,
    DlgArticleEmailGenerator,
    Card,
  },
})
export default class AdsList extends Vue {
  @Getter('articles/all') private articles!: any[];
  @Getter('articles/clickedBy') private clickedBy!: any[];
  @Action('articles/read') private readAll!: any;
  @Action('articles/articleClickedBy') private readClickers!: any;
  private loading: boolean = false;
  private dlgDelete: boolean = false;
  private selected: any = {};

  private search: string = '';

  private async created() {

    this.loading = true;
    await this.readAll();
    this.loading = false;
  }

  private getImageUrl(text: string) {
    if (!text) {
      return `/img/logo.png`;
    }
    return `https://images.ihrespezialisten.at${text.replace('full', 'resized')}`;
  }

  private deleteArticle(article: any) {
    this.selected = JSON.parse(JSON.stringify(article));
    this.dlgDelete = true;
  }

  private async openedPanel(article: any) {
    if (!this.clickedBy[article.id]) {
      await this.readClickers(article);
    }
  }

  private getClickedBy(article: any) {
    return this.clickedBy[article.id];
  }
}
